import aboutUsTitle from "../../assets/images/base/Group 1.jpg";
import aboutUsImg from "../../assets/images/base/pic left.jpg";
import { useState } from "react";
import ProductModal from "./ProductModal";
import i1 from "../../assets/images/aboutUs/1.jpg";
import i2 from "../../assets/images/aboutUs/2.jpg";
import i3 from "../../assets/images/aboutUs/3.jpg";
import i4 from "../../assets/images/aboutUs/4.jpg";
import i5 from "../../assets/images/aboutUs/5.jpg";
import i6 from "../../assets/images/aboutUs/6.jpg";
import i7 from "../../assets/images/aboutUs/7.jpg";
import i8 from "../../assets/images/aboutUs/8.jpg";
import i9 from "../../assets/images/aboutUs/9.jpg";
import i10 from "../../assets/images/aboutUs/10.jpg";

export default function AboutUs() {
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <div className="about-us">
      <img src={aboutUsTitle} className="w-100" />

      <div className="d-flex about-us-container justify-content-between">
        {" "}
        <div
          className="d-flex align-items-center about-us-text"
          // style={{ fontWeight: "bold" }}
        >
          در ابتدا این مجموعه با نام تجاری ایران کاور در سال 1384 به منظور تولید
          لباسهای فرم نظامی و روپوشهای بیمارستانی- صنعتی تأسیس گردید و موفقیتهای
          چشمگیری نیز حاصل آمد که از این جمله می توان به تولید بتلهای نیروی
          دریایی ارتش جمهوری اسلامی ایران، لباسهای کارخانجات مختلف از قبیل شرکت
          دخانیات، شرکت کشت و صنعت، شرکت سهامی صنایع شیر ایران (پگاه) و دهها
          مورد کاری دیگر اشاره کرد. از سال 1385 طراحان صدرا بی بافت صنعت هیرکان
          در راستای بهینه سازی در زمینه تولید و مصرف با طراحی به روز کاورهای
          صنعتی- تبلیغاتی Nonwoven که برای اولین بار در ایران انجام شد، تحولی
          شگرف را در صنعت تبلیغات برداشت که به زعم گفته تمامی دست اندرکاران صنعت
          چاپ و تبلیغات مرغوبترین و نازلترین قیمت را داراست. با گذشت زمان و بالغ
          شدن این صنعت نوپا، برای راضی نگهداشتن مشتریان و صاحبان صنایع وابسته به
          صنعت تبلیغات که تقریباً تمامی صنعت کاران و کانونهای تبلیغاتی را در بر
          می گیرد، صدرا بی بافت صنعت هیرکان با کمال میل حرکت به سوی نوآوری و
          خلاقیتهای ذاتی که جزء لاینفک از این مجموعه می باشد را آغاز کرده و
          محصولات بی نظیری را به مشتریان عرضه داشته است. از سال 1390 این مجموعه
          با به روز شدن به تکنولوژی التراسونیک در زمینه تولید کیسه های مختلف با
          حجم تولید بالا و کیفیتی مثال زدنی، محصولاتی متفاوت و متنوعی را به عرضه
          ظهور رسانده است. در حال حاضر صدرا بی بافت صنعت هیرکان با تولیدی روزانه
          معادل 50000 عدد ساک دستی بزرگترین تولید کننده و با بیش از 500 مشتری
          ثابت بزرگترین توزیع کننده به همه اصناف می باشد.
        </div>
        <img
          className=""
          style={{ cursor: "pointer" }}
          src={aboutUsImg}
          onClick={() => {
            setShowModal(true);
          }}
        />
      </div>
      <ProductModal
        show={showModal}
        closeModal={closeModal}
        name="درباره ما"
        type="about-us"
        productModalData={[
          { src: i1 },
          { src: i2 },
          { src: i3 },
          { src: i4 },
          { src: i5 },
          { src: i6 },
          { src: i7 },
          { src: i8 },
          { src: i9 },
          { src: i10 },
        ]}
      />
    </div>
  );
}
